import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmile } from "@fortawesome/free-solid-svg-icons";

const SaveOffer = ({ totalSavings }) => {
  return (
    <Card
      className="my-3"
      style={{
        border: "1px dashed #a2a2a2",
        borderRadius: "5px",
        padding: "15px",
        textAlign: "center",
      }}
    >
      <div
        className="tot-save-amt"
        style={{
          fontSize: "20px",
          paddingBottom: "12px",
          borderBottom: "1px dashed #a2a2a2",
          color: "#ff4700",
          display: "block",
          width: "100%",
          marginBottom: "12px",
        }}
      >
        <FontAwesomeIcon icon={faSmile} style={{ marginRight: "8px" }} />
        You Saved!&nbsp;
        <span style={{ fontWeight: "bold", fontSize: "22px" }}>
          ₹ {totalSavings.toFixed(2)}
        </span>
      </div>
      {/* Uncomment if you want to add coins or any other element below */}
      {/* <div className="total-coins" style={{ marginTop: "10px" }}>
        <strong>You Earned</strong> : 0 Coins
        <img
          src="https://www.graceonline.in/assets/img/coin.png"
          alt="coins"
          style={{ width: "20px", marginLeft: "5px" }}
        />
      </div> */}
    </Card>
  );
};

export default SaveOffer;
